<template>
  <div class="headerBox">
    <div class="headerText">首页</div>
    <div class="headerText">热门</div>
    <div class="headerText">探索</div>
    <div class="searchBox">
      <input type="text" placeholder="Grayscale ARB" class="inputText" >
      <div class="searchIconBox">
        <img src="@/assets/search.png" class="searchIcon" alt=""/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Demo',
  setup() {
  },
  methods: {
   
  }
}
</script>

<style lang="less" scoped>
.headerBox{
  width: 100%;
  padding: 18px 120px;
  overflow: hidden;
  background: #121212;
  .headerText{
    float: left;
    height: 40px;
    line-height: 40px;
    font-size: 16px;
    margin:0 50px 0 0 ;
    font-weight: bold;
    color: #fff;
  }
  .searchBox{
    height: 40px;
    width: 664px;
    border-radius: 8px;
    background: #1D1D1E;
    float: left;
    padding: 0 0 0 16px;
    .inputText{
      float: left;
      display: block;
      width: 608px;
      height: 40px;
      border: none;
      background: none;
      padding: 0;
      margin: 0;
      outline: none;
      color:#fff;
    }
    .searchIconBox{
      width: 40px;
      height: 40px;
      float: right;
      padding:11.5px;
      cursor: pointer;
      .searchIcon{
      width: 17px;
      height: 17px;
    }
    }
    
  }
}
</style>
